import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authService } from "../services/auth.service";
import { socketService } from "../services/socket.service";

export const loginUser = createAsyncThunk("user/login", async (credentials, thunkAPI) => {
  try {
    const data = await authService.login(credentials);
    return data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || "Login failed");
  }
});

export const refreshUserToken = createAsyncThunk("user/refresh", async (_, thunkAPI) => {
  try {
    const data = await authService.refreshAuthToken();
    return data.user;
  } catch (err) {
    return thunkAPI.rejectWithValue("Token refresh failed");
  }
});

export const getCurrentUser = createAsyncThunk("user/getCurrentUser", async (_, thunkAPI) => {
  try {
    const userData = await authService.getCurrentUser();
    return userData;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || "Failed to fetch user data");
  }
});

export const logoutUser = createAsyncThunk(
  "user/logout",
  async (_, thunkAPI) => {
    try {
      //   NOUVEAU : déconnecter SignalR AVANT d'invalider le token
      try {
        await socketService.disconnect();
      } catch (e) {
        console.warn('[Logout] socketService.disconnect failed:', e);
      }

      await authService.logout();
      return null;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err?.response?.data || "Logout failed"
      );
    }
  }
);

const authSlice = createSlice({
  name: "user",
  initialState: { user: null, loading: false, error: null },
  reducers: {
    initializeAuth: (state) => {
      // Initialize auth state from localStorage if valid token exists
      if (authService.getAccessToken()) {
        state.user = { authenticated: true };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCurrentUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCurrentUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(getCurrentUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(refreshUserToken.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
      });
  },
});

export const { initializeAuth } = authSlice.actions;
export default authSlice.reducer;